import { hyperdbHandlers } from 'hyperdb-utils';

export default hyperdbHandlers({ namespace: 'PAYMENT' });



// WEBPACK FOOTER //
// ./src/frontend/modules/daily-rental/payment/handlers.js